import { Link } from 'react-router-dom'

export default function LandingFooter() {
    return (
        <footer className="mx-auto mt-[60px] max-w-[1142px] px-4 pb-10 md:pb-[74px] lg:mt-[203px]">
            <div className="inline-flex flex-col items-start justify-start gap-6 md:flex-row lg:gap-40">
                <div className="inline-flex flex-1 flex-col items-start justify-start gap-16">
                    <div className="flex flex-col items-start justify-start gap-8 self-stretch">
                        <Link to="/">
                            <img
                                src="/images/logo.png"
                                className="h-10 w-[166px]"
                                alt="Logo"
                            />
                        </Link>
                        <div className="justify-start self-stretch font-circular text-base leading-[160%] text-gray-900/50 md:text-[23px]">
                            TokReach is not affiliated with or endorsed by
                            TikTok or ByteDance Ltd. All trademarks belong to
                            their respective owners. Results vary based on
                            content, posting, and audience.
                        </div>
                    </div>
                </div>
                <div className="flex flex-col items-start justify-start gap-8 md:flex-row md:gap-32">
                    <div className="inline-flex flex-col items-start justify-start gap-6 md:gap-8">
                        <div className="justify-start font-circular text-2xl font-bold leading-[160%] text-gray-900">
                            Company
                        </div>
                        <Link
                            to="/terms-of-use"
                            className="justify-start font-inter text-base font-normal leading-[160%] text-gray-900/75 md:text-lg"
                        >
                            Terms of Use
                        </Link>
                        <Link
                            to="/privacy-policy"
                            className="justify-start font-inter text-base font-normal leading-[160%] text-gray-900/75 md:text-lg"
                        >
                            Privacy Policy
                        </Link>
                        <Link
                            to="/refund-policy"
                            className="justify-start font-inter text-base font-normal leading-[160%] text-gray-900/75 md:text-lg"
                        >
                            Refund Policy
                        </Link>
                    </div>
                    <div className="inline-flex flex-col items-start justify-start gap-6 md:gap-8">
                        <div className="justify-start font-circular text-2xl font-bold leading-[160%] text-gray-900">
                            Contact Us
                        </div>
                        <a
                            href="mailto:support@tokreach.co"
                            className="justify-start font-inter text-base font-normal leading-[160%] text-gray-900/75 md:text-lg"
                        >
                            support@tokreach.co
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    )
}
